<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Variance Report</h5>
  </div>
<div id="mainContent" class="container">
    <div class="modal-body">
        <div class="row">
            <div class="col-sm-5">
           <div class="row">
               <div class="col-sm-4">
                <label class="col-form-label">Level</label>
            </div>
                <div class="col-sm-6">
              <select
                class="form-control form-control-xs mt-1"
                [(ngModel)]="selectedLevel"
                (change)="onLevelChange()"
              >
                <option value="firmLevel">Variation Firm Level</option>
                <option value="partnerLevel">Variation Partner Level</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label">Financial Year</label>
            <div class="col-sm-6">
              <select
                class="form-control form-control-xs mt-1"
                [(ngModel)]="selectedFinancialYear"
                (change)="onFYSelected()"
              >
                <option value="">Select Year</option>
                <option *ngFor="let finance of financialList" [ngValue]="finance">
                  {{ finance.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
    </div>

      <div class="row mt-3">
        <div class="col-sm-5" *ngIf="selectedLevel=='partnerLevel'">
          <div class="row">
            <label class="col-sm-4 col-form-label">Partner</label>
            <div class="col-sm-6">
              <select
                ngbAutofocus
                class="form-control form-control-xs"
                id="partner"
                name="partner"
                [(ngModel)]="selectPartner"
              >
                <option value="">Select Partner Name</option>
                <option *ngFor="let partner of partnerList" [ngValue]="partner">
                  {{ partner.firstName }} {{ partner.lastName }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-5" >
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group mb-0" style="margin-top: -2%">
                <div class="form-check form-check-inline pr-5" >
                  <input
                    class="form-check-input"
                    type="radio"
                    name="Cost"
                    id="Cost"
                    [(ngModel)]="selectCostManDays"
                    [value]="0"
                  />
                  <label class="col-form-label ml-3" style="font-weight: 400"
                    >Cost</label
                  >
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="mandays"
                    id="mandays"
                    [(ngModel)]="selectCostManDays"
                    [value]="1"
                  />
                  <label class="col-form-label ml-3" style="font-weight: 400"
                    >Man Days</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-2">
          <button
            class="btn btn-sm btn-block btn-outline-theme"
            (click)="viewReport()"
          >
            ViewReport
          </button>
        </div>
        
        <div class="col-sm-2">
          <button
            class="btn btn-sm btn-block btn-outline-theme"
            (click)="exportToExcelVarianceReport()"
            *ngIf="showExcelButton"
          >
            Export to Excel
          </button>
        </div>
      </div>
      </div>
  </div>


  <div class="container pt-3" id="mainContent" *ngIf="reportList && this.selectCostManDays == 0">
    <div class="row justify-content-center text-center">
      <span class="bg-theme-title"
        >P G BHAGWAT LLP, Chartered Accountants
      </span>
    </div>
    <div class="row justify-content-center text-center ">
      <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
    </div>
    <div>
      <div class="row justify-content-center text-center mt-2">
        <span class="bg-theme-title"
          >VARIATION SUMMARY REPORT FOR FY {{ selectedFinancialYear.name }}</span
        >
    </div>
    <div class="row col-md-12 mt-3" *ngIf="selectedLevel=='firmLevel'">
        <table
          class="table table-bordered table-sm"
          style="display: block; overflow-x: auto; white-space: nowrap"
        >
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Partner</th>
              <th>Budgeted Fees(Rs)</th>
              <th>Total Budgeted Cost(Rs)</th>
              <th>Budgeted Contribution(Rs)</th>
              <th>Budgeted Contribution(%)</th>
              <th>Budgeted Fees(Rs)</th>
              <th>Total Actual Cost(Rs)</th>
              <th>Actual Contribution(Rs)</th>
              <th>Actual Contribution(%)</th>
              <th>Variation in Contribution</th>
              <th>Variation in Contribution(%)</th>
            </tr>
          </thead>
          <tbody *ngFor="let data of reportList.costRest;let i=index;">
            <td>{{i+1}}</td>
            <td>{{data.name}}</td>
            <td>{{data.budgetedFees}}</td>
            <td>{{data.budgetedCost}}</td>
            <td>{{data.budgetedContributiont}}</td>
            <td>{{data.budgetedContributionInPercentage}}</td>
            <td>{{data.budgetedFees}}</td>
            <td>{{data.actualCost}}</td>
            <td>{{data.actualContribution}}</td>
            <td>{{data.actualContributionPercentage }}</td>
            <td>{{data.variationInContribution}}</td>
            <td>{{data.variationInContributionPercentage }}</td>
          </tbody>

          <tfoot style="background-color: #87cefa;">
            <tr>
              <td>Total</td>
              <td></td>
              <td>{{reportList.totalBudgetedFees}}</td>
              <td>{{reportList.totalBudgetedCost}}</td>
              <td>{{reportList.totalBudgetedContribution}}</td>
              <td>{{reportList.totalBudgetedContributionInPercentage }}</td>
              <td>{{reportList.totalBudgetedFees}}</td>
              <td>{{reportList.totalActualCost}}</td>
              <td>{{reportList.totalActualContribution}}</td>
              <td>{{reportList.totalActualContributionPercentage}}</td>
              <td>{{reportList.totalVariationInContribution}}</td>
              <td>{{reportList.totalVariationInContributionPercentage}}</td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div class="row col-md-12 mt-3" *ngIf="selectedLevel=='partnerLevel'">
        <table
          class="table table-bordered table-sm"
          style="display: block; overflow-x: auto; white-space: nowrap"
        >
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Client</th>
              <th>Budgeted Fees(Rs)</th>
              <th>Total Budgeted Cost(Rs)</th>
              <th>Budgeted Contribution(Rs)</th>
              <th>Budgeted Contribution(%)</th>
              <th>Budgeted Fees(Rs)</th>
              <th>Total Actual Cost(Rs)</th>
              <th>Actual Contribution(Rs)</th>
              <th>Actual Contribution(%)</th>
              <th>Variation in Contribution</th>
              <th>Variation in Contribution(%)</th>
            </tr>
          </thead>
          <tbody *ngFor="let data of reportList.multi;let i=index;">
            <td>{{i+1}}</td>
            <td>{{data.name}}</td>
            <td>{{data.budgetedFees}}</td>
            <td>{{data.costsDetails.budgetedcost}}</td>
            <td>{{data.costsDetails.budgetedcontribution}}</td>
            <td>{{data.costsDetails.budgetedcontributionInPercentage}}</td>
            <td>{{data.budgetedFees}}</td>
            <td>{{data.costsDetails.actualcost}}</td> 
            <td>{{data.costsDetails.actualcostcontribution}}</td>
            <td>{{data.costsDetails.actualcostcontributionInPercentage}}</td>
            <td>{{data.costsDetails.varianceInContribution}}</td>
            <td>{{data.costsDetails.varianceInContributionInPercentage}}</td>
          </tbody>

          <tfoot style="background-color: #87cefa;">
            <tr>
              <td>Total</td>
              <td></td>
              <td>{{allTotalBudgetedFee}}</td>
              <td>{{allTotalBudgetedCost}}</td>
              <td>{{allTotalBudgetedContribution}}</td>
              <td>{{allTotalBudgetedContributionPer }}</td>
              <td>{{allTotalBudgetedFee}}</td>
              <td>{{allTotalActualCost}}</td>
              <td>{{allTotalActualContribution}}</td>
              <td>{{allTotalActualContributionPer}}</td>
              <td>{{allTotalVarianceContribution}}</td>
              <td>{{allTotalVarianceContributionPer}}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>  
    </div>
  

     <!-- <div
    class="container tablefont pt-3" id="mainContent"
    *ngIf="reportList != null"
  >
    <div class="row justify-content-center text-center">
      <span class="bg-theme-title">P G BHAGWAT LLP, Chartered Accountants</span>
    </div>
    <div class="row justify-content-center text-center ">
      <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
    </div>
    <div class="row col-md-12 pt-3">
      <table class="table table-bordered table-sm" style="overflow-x: auto; white-space: nowrap; display: block;">
        <thead>
          <tr>
            <th rowspan="2">Partner</th>
            <th [attr.colspan]="distinctRoles.length">Budgeted Man Days</th>
            <th [attr.colspan]="distinctRoles.length">Actual Man Days</th>
            <th rowspan="2">Total Cost</th>
            <th rowspan="2">Fees</th>
            <th rowspan="2">Contribution</th>
            <th rowspan="2">Contribution %</th>
          </tr>
          <tr>
            <th *ngFor="let role of distinctRoles">{{ role }}</th>
            <th *ngFor="let role of distinctRoles">{{ role }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let client of reportList.variancePartnerRests; let clientIndex = index">
            <tr>
              <td [attr.rowspan]="client.roles.length" *ngIf="clientIndex === 0">{{ client.name }}</td>
              <td *ngFor="let role of client.roles">{{ role.budgetedManDays }}</td>
              <td *ngFor="let role of client.roles">{{ role.actualManDays }}</td>
              <td>{{ client.totalBudgetedMandays }}</td>
              <td>{{ client.totalActualMandays }}</td>
              <td>{{ client.variation }}</td>
              <td>{{ client.variationPercent | number: '1.2-2' }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div> -->
 

  <div class="container tablefont pt-3" id="mainContent2" *ngIf="reportList != null && this.selectCostManDays == 1 && this.selectedLevel == 'firmLevel'">
    <div class="row justify-content-center text-center">
      <span class="bg-theme-title">P G BHAGWAT LLP, Chartered Accountants</span>
    </div>
    <div class="row justify-content-center text-center ">
      <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
    </div>
    <div class="row col-md-12 pt-3">
      <table class="table table-bordered table-sm" style="overflow-x: auto; white-space: nowrap; display: block;">
        <thead>
          <tr>
            <th rowspan="2">Partner</th>
            <th [attr.colspan]="distinctRoles.length">Budgeted Man Days</th>
            <th [attr.colspan]="distinctRoles.length">Actual Man Days</th>
            <th rowspan="2">Total Budgeted Mandays</th>
            <th rowspan="2">Total Actual Mandays</th>
            <th rowspan="2">Variation</th>
            <th rowspan="2">Variation %</th>
          </tr>
          <tr>
            <th *ngFor="let role of distinctRoles">{{ role }}</th>
            <th *ngFor="let role of distinctRoles">{{ role }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let client of reportList.variancePartnerRests; let clientIndex = index">
            <tr>
              <td >{{ client.name }}</td>
              <td *ngFor="let role of client.roles">{{ role.budgetedManDays }}</td>
              <td *ngFor="let role of client.roles">{{ role.actualManDays }}</td>
              <td>{{ client.totalBudgetedMandays }}</td>
              <td>{{ client.totalActualMandays }}</td>
              <td>{{ client.variation }}</td>
              <td>{{ client.variationPercent | number: '1.2-2' }}</td>
            </tr>
            <!-- <tr *ngIf="clientIndex > 0">
              <td>{{ client.name }}</td>
              <td *ngFor="let role of client.roles">{{ role.budgetedManDays }}</td>
              <td *ngFor="let role of client.roles">{{ role.actualManDays }}</td>
              <td>{{ client.totalBudgetedMandays }}</td>
              <td>{{ client.totalActualMandays }}</td>
              <td>{{ client.variation }}</td>
              <td>{{ client.variationPercent | number: '1.2-2' }}</td>
            </tr> -->
          </ng-container>
          <tr>
            <td>Total</td>
            <td *ngFor="let role of distinctRoles">
            </td>
            <td *ngFor="let role of distinctRoles">
            </td>
            <td >{{totalPartnerBudgetedMandays}}</td>
            <td >{{totalPartnerActualMandays}}</td>
            <td ></td>
            <td ></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  
  
  <div
  class="container tablefont pt-3" id="mainContent3"
  *ngIf="reportList != null && this.selectCostManDays == 1 && this.selectedLevel == 'partnerLevel'"
>
<div class="row justify-content-center text-center">
  <span class="bg-theme-title"
    >P G BHAGWAT LLP, Chartered Accountants
  </span>
</div>
<div class="row justify-content-center text-center ">
  <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
</div>
<div class="row col-md-12 pt-3">
  <table class="table table-bordered table-sm" style="overflow-x: auto; white-space: nowrap; display: block;">
    <thead>
      <tr>
        <!-- <th rowspan="2">Branch</th> -->
        <th rowspan="2">Client</th>
        <th rowspan="2">Assignment</th>
        <!-- <th [attr.colspan]="distinctRoles.length">Budgeted Man Days</th>
        <th [attr.colspan]="distinctRoles.length">Budgeted Count</th> -->
        <th [attr.colspan]="distinctRoles.length">Budgeted Man Days</th>
        <th [attr.colspan]="distinctRoles.length">Actual Man Days</th>
        <th rowspan="2">Total Budgeted Mandays</th>
        <th rowspan="2">Total Actual Mandays</th>
        <th rowspan="2">Variation</th>
        <th rowspan="2">Variation %</th>
      </tr>
      <tr>
        <!-- <th *ngFor="let role of distinctRoles">{{ role }}</th>
        <th *ngFor="let role of distinctRoles">{{ role }}</th> -->
        <th *ngFor="let role of distinctRoles">{{ role }}</th>
        <th *ngFor="let role of distinctRoles">{{ role }}</th>
      </tr>
    </thead>
    <tbody>
      <ng-container
        *ngFor="
          let client of reportList.clients;
          let clientCount = count;
          let clientIndex = index
        "
      >
        <ng-container
          *ngFor="
            let assignment of client.assignments;
            let assignmentIndex = index;
            let assignmentCount = count
          "
        >
          <tr>
            <td
              [attr.rowspan]="assignmentCount"
              *ngIf="assignmentIndex == 0"
            >
              {{ client.client }}
            </td>
            <td>{{ assignment.assignment }}</td>
            <td *ngFor="let role of assignment.roles">
              {{ role.budgetedManDays }}
            </td>
            <td *ngFor="let role of assignment.roles">
              {{ role.actualManDays }}
            </td>
            <td>{{ assignment.totalBudgetedMandays }}</td>
            <td>{{ assignment.totalActualMandays }}</td>
            <td>{{ assignment.variation }}</td>
            <td>
              {{ assignment.variationPercent | number: "1.2-2" }}
            </td>
          </tr>
          <!-- <tr
            class="table-footer"
            *ngIf="assignmentIndex == assignmentCount - 1"
          >
            <td>Total</td>
            <td *ngFor="let role of assignment.roles">
              {{ getTotalManDays(client, role.role) }}
            </td>
            <td *ngFor="let role of assignment.roles">
              {{ getTotalCount(client, role.role) }}
            </td>
            <td *ngFor="let role of assignment.roles">
              {{ getTotalTotalManDays(client, role.role) }}
            </td>
            <td *ngFor="let role of assignment.roles">
              {{ getTotalTotalCost(client, role.role) }}
            </td>
            <td>{{ getTotalBudget(client) }}</td>
            <td>{{ getTotalFees(client) }}</td>
            <td>{{ getTotalContribution(client) }}</td>
            <td>{{ getTotalPercentage(client) | number: "1.2-2" }}</td>
          </tr> -->

          <!-- <tr
            *ngIf="
              assignmentIndex == assignmentCount - 1 &&
              clientIndex == clientCount -1
            "
            style="background-color: lightskyblue"
          >
            <td></td>
            <td>Total</td>
            <td></td>
            <td *ngFor="let role of assignment.roles">
              {{ getAllTotalManDays(role.role) }}
            </td>
            <td *ngFor="let role of assignment.roles">
              {{ getAllTotalCount(role.role) }}
            </td>
            <td *ngFor="let role of assignment.roles">
              {{ getAllTotalTotalManDays(role.role) }}
            </td>
            <td *ngFor="let role of assignment.roles">
              {{ getAllTotalTotalCost(role.role) }}
            </td>
            <td>{{ getAllTotalBudget() }}</td>
            <td>{{ getAllTotalFees() }}</td>
            <td>{{ getAllTotalContribution() }}</td>
            <td>{{ getAllTotalPercentage() | number: "1.2-2" }}</td>
          </tr> -->
        </ng-container>
      </ng-container>
      <tr>
        <td>Total</td>
        <td></td>
        <td *ngFor="let role of reportList.clients[0].assignments[0].roles">
        </td>
        <td *ngFor="let role of reportList.clients[0].assignments[0].roles">
        </td>
        <td >{{totalPartnerBudgetedMandaysPartnerLevel}}</td>
        <td >{{totalPartnerActualMandaysPartnerLevel }}</td>
        <td >{{reportList.totalBudgetedContribution}}</td>
        <td >{{reportList.totalBudgetedContributionPercentage}}</td>
      </tr>
    </tbody>
  </table>
</div>
</div>


        </div>
